import React from 'react'
import {
  ICheckboxProps,
  ILabelItem,
} from '../../../types/interfaces/ICheckboxProps'
import { Error } from '../error/Error'
import {
  CheckboxContainer,
  Input,
  Label,
  InnerContainer,
  InputWrapper,
  ErrorWrapper,
} from './style'
import { HeightPlaceHolderForError } from '../email-confirm-input/style'

export const Checkbox: React.FC<ICheckboxProps> = ({
  hasError,
  errorText,
  callback,
  id,
  label,
  linkLabel,
  href,
  labelItems,
  checked,
  className,
  isWhite,
}) => {
  return (
    <>
      <CheckboxContainer
        className={`checkbox ${className ?? ''} ${hasError ? 'error' : ''} ${isWhite ? 'white' : ''}`}
      >
        <ErrorWrapper $hasError={hasError}>
          <HeightPlaceHolderForError>
            <Error hasError={hasError} errorText={errorText} />
          </HeightPlaceHolderForError>
        </ErrorWrapper>

        <InnerContainer>
          <InputWrapper>
            <Input
              id={id}
              type="checkbox"
              checked={checked}
              onChange={(e: any) => callback(e)}
              className={checked ? 'checked' : ''}
            />
          </InputWrapper>

          <Label htmlFor={id}>
            {labelItems && labelItems.length > 0 ? (
              <>
                {labelItems.map((item: ILabelItem, index: number) => {
                  const itemKey = item.href ? item.href : item.text

                  if (item.href) {
                    return (
                      <a
                        key={itemKey}
                        target="_blank"
                        href={item.href}
                        rel="noreferrer"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {item.text}
                      </a>
                    )
                  }
                  return <span key={index}>{item.text}</span>
                })}
              </>
            ) : (
              <>
                {label}{' '}
                {linkLabel && (
                  <a
                    target="_blank"
                    href={href}
                    rel="noreferrer"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {linkLabel}
                  </a>
                )}
              </>
            )}
          </Label>
        </InnerContainer>
      </CheckboxContainer>
    </>
  )
}
export default Checkbox
